import React from "react";
import {
  Box,
  Select,
  MenuItem,
  SvgIcon,
  Typography,
  CircularProgress,
} from "@mui/material";
import { ReactComponent as DropArrowIcon } from "../../Icons/SelectDropdownArrow.svg";
import {
  TypoGraph,
  StyledSecondaryServiceTypography,
  StyledSecondaryTypography,
} from "../../Theme";
import { ReactComponent as ActiveIcon } from "../../Icons/ActiveGraph.svg";
import { ReactComponent as InactiveIcon } from "../../Icons/InactiveIcon.svg";
import { ReactComponent as OffBoardIcon } from "../../Icons/OffBoardIcon.svg";
import Chart from "react-apexcharts";
import { ReactComponent as ExclamatoryIcon } from "../../Icons/GraphExclamatoryIcon.svg";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Indicator from "../../Icons/tooltipIndicator.svg";

const ParcelCollectionGraph = () => {
  const graphData = [1, 1221];
  const { ParcelCollectionData, OverviewStatus } = useSelector(
    (state) => state.OverView
  );
  const { LanguageData } = useSelector((state) => state.Language);

  const ParcelCollectionSeries = [
    {
      name: "Collected",
      data: [
        ParcelCollectionData?.jan?.collected || 0,
        ParcelCollectionData?.feb?.collected || 0,
        ParcelCollectionData?.mar?.collected || 0,
        ParcelCollectionData?.apr?.collected || 0,
        ParcelCollectionData?.may?.collected || 0,
        ParcelCollectionData?.jun?.collected || 0,
        ParcelCollectionData?.jul?.collected || 0,
        ParcelCollectionData?.aug?.collected || 0,
        ParcelCollectionData?.sep?.collected || 0,
        ParcelCollectionData?.oct?.collected || 0,
        ParcelCollectionData?.nov?.collected || 0,
        ParcelCollectionData?.dec?.collected || 0,
      ],
    },
    {
      name: "Uncollected",
      data: [
        ParcelCollectionData?.jan?.uncollected || 0,
        ParcelCollectionData?.feb?.uncollected || 0,
        ParcelCollectionData?.mar?.uncollected || 0,
        ParcelCollectionData?.apr?.uncollected || 0,
        ParcelCollectionData?.may?.uncollected || 0,
        ParcelCollectionData?.jun?.uncollected || 0,
        ParcelCollectionData?.jul?.uncollected || 0,
        ParcelCollectionData?.aug?.uncollected || 0,
        ParcelCollectionData?.sep?.uncollected || 0,
        ParcelCollectionData?.oct?.uncollected || 0,
        ParcelCollectionData?.nov?.uncollected || 0,
        ParcelCollectionData?.dec?.uncollected || 0,
      ],
    },
  ];

  const options = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: {
        show: false,
      },
      events: {
        mouseMove: (event, chartContext) => {
          chartContext.el.style.cursor = "pointer";
        },
        mouseLeave: (event, chartContext) => {
          chartContext.el.style.cursor = "default";
        },
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      labels: {
        style: {
          fontSize: "12px",
          fontFamily: "Inter, sans-serif",
          color: "#384250",
          fontWeight: 400,
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return value;
        },
        style: {
          fontSize: "12px",
          fontFamily: "Inter, sans-serif",
          color: "#384250",
          fontWeight: 400,
        },
      },
    },
    colors: ["#1687BD", "#FF7C32"],
    legend: {
      show: false,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        // borderRadius: 8,
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      theme: false,
      style: {
        background: "#262D33",
      },
      x: {
        show: false,
      },
      y: {
        title: {
          formatter: function () {
            return "";
          },
        },
      },
      marker: {
        show: false,
      },
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const total = series[0][dataPointIndex] + series[1][dataPointIndex];
        const active = series[0][dataPointIndex];
        const inactive = series[1][dataPointIndex];
        const month = w.globals.labels[dataPointIndex];

        return `
        <div class="background">
        <div class="triangle">
       
        <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 16V0L1.5 6.5L0.5 7.5L0 8L8 16Z" fill="#262D35"/>
</svg>
        </div>
        <div class="apexcharts-tooltip-custom">
        <div class="total-count-tip">
            <div>
                Total
            </div> 
            <div>
                ${total} 
            </div>
        </div>
        <div class="tool-tip-parent">
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                    <rect x="0.490234" y="0.305664" width="8" height="8" rx="2" fill="#1687BD"/>
                </svg>
                Collected
            </div>
            <div>
                ${active}
            </div>
        </div>
        <div class="tool-tip-parent">
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                    <rect x="0.490234" y="0.305664" width="8" height="8" rx="2" fill="#FF7C32"/>
                </svg>
                Uncollected
            </div> 
            <div>
                ${inactive}
            </div>
        </div>
        <div class="month-change-top">${month}${" "}${2023}</div>
    </div>
    </div>
    
          `;
      },
    },
    states: {
      normal: {
        filter: {
          type: "none",
          value: 0,
        },
      },
      hover: {
        filter: {
          type: "none",
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: "none",
          value: 0,
        },
      },
    },
   
  };

  return (
    <>
      {
        <>
          <Box
            sx={{
              borderBottom: "1px solid #E5E7EB",
              borderTop: "1px solid #E5E7EB",
              padding: "16px",
              backgroundColor: "#FCFCFD",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Box>
                <StyledSecondaryServiceTypography style={{ fontWeight: 500 }}>
                  {` ${
                    LanguageData?.home_total_parcel || "Total Parcels"
                  }${" "}${ParcelCollectionData?.total_count || 0} `}
                </StyledSecondaryServiceTypography>
              </Box>
            </Box>
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    marginRight: "20px",
                    alignItems: "center",
                  }}
                >
                  <ActiveIcon style={{ marginRight: "10px" }} />
                  <TypoGraph>
                    {LanguageData?.home_collected || "Collected"}
                  </TypoGraph>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginRight: "20px",
                  }}
                >
                  <InactiveIcon style={{ marginRight: "10px" }} />
                  <TypoGraph>
                    {LanguageData?.home_uncollected || "Uncollected"}
                  </TypoGraph>
                </Box>
              </Box>
            </Box>
          </Box>
          {ParcelCollectionData.total_count ? (
            <Box
              sx={{
                borderRadius: "0px 0px 8px 8px",
                backgroundColor: "#FFFFFF",
              }}
            >
              <Chart
                options={options}
                series={ParcelCollectionSeries}
                type="bar"
                height={400}
              />
            </Box>
          ) : (
            <Box
              sx={{
                borderRadius: "0px, 0px, 8px, 8px",
                padding: "16px",
                backgroundColor: "#F9FAFB",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "300px",
              }}
            >
              {OverviewStatus ? (
                <CircularProgress />
              ) : (
                <>
                  {" "}
                  <ExclamatoryIcon
                    style={{ marginBottom: "5px", marginTop: "60px" }}
                  />
                  <Typography
                    sx={{
                      color: "#9DA4AE",
                      fontSize: "16px",
                      fontWeight: 600,
                      width: "470px",
                      my: 2,
                      textAlign: "center",
                      marginTop: "5px",
                      marginBottom: "100px",
                    }}
                    style={{ color: "#4D5761" }}
                  >
                    No statistics available for display
                  </Typography>
                </>
              )}
            </Box>
          )}
        </>
      }
    </>
  );
};

export default ParcelCollectionGraph;
